/* @flow */

import { includes, chain } from 'lodash'

import type {
  RootState,
  Action,
  Design,
  PollTypeId,
  DesignsStore,
} from '../types'
import { upsert } from '../helpers'

// TODO this data should not be hardcoded but should come from
// an API endpoint

// TODO this could ideally be modeled by having two tables:
//
// design
//    id
//    name
//    ... properties that are shared for this design for every poll type
//
// design_poll_type
//    design_id
//    poll_type_id
//    ... properties that are specific to this design and poll type
//

export const hardcodedDesigns: Array<Design> = [
  {
    id: '1und1',
    name: '1und1',
    pollTypeIds: ['one-axis', 'two-axes'],
  },
  {
    id: 'ozy_immodest_proposal',
    name: 'ozy_immodest_proposal',
    pollTypeIds: ['one-axis'],
  },
  {
    id: 'ozy_acumen',
    name: 'ozy_acumen',
    pollTypeIds: ['one-axis'],
  },
  {
    id: 'ozy_flashback',
    name: 'ozy_flashback',
    pollTypeIds: ['one-axis'],
  },
  {
    id: 'ozy_good_sh*t',
    name: 'ozy_good_sh*t',
    pollTypeIds: ['one-axis'],
  },
  {
    id: 'ozy_performance',
    name: 'ozy_performance',
    pollTypeIds: ['one-axis'],
  },
  {
    id: 'ozy_provocateurs',
    name: 'ozy_provocateurs',
    pollTypeIds: ['one-axis'],
  },
  {
    id: 'ozy_rising_star',
    name: 'ozy_rising_star',
    pollTypeIds: ['one-axis'],
  },
  {
    id: 'welt',
    name: 'welt',
    pollTypeIds: ['one-axis', 'two-axes'],
  },
  {
    id: 'wiwo',
    name: 'wiwo',
    pollTypeIds: ['one-axis', 'financial'],
  },
  {
    id: 'express',
    name: 'express',
    pollTypeIds: ['one-axis'],
  },
  {
    id: 'focus',
    name: 'focus',
    pollTypeIds: ['one-axis', 'two-axes'],
  },
  {
    id: 'morgenpost',
    name: 'morgenpost',
    pollTypeIds: ['one-axis'],
  },
  {
    id: 'huffingtonpost',
    name: 'huffingtonpost',
    pollTypeIds: ['one-axis'],
  },
  {
    id: 'spiegel',
    name: 'spiegel',
    pollTypeIds: ['one-axis', 'two-axes'],
  },
  {
    id: 'meedia',
    name: 'meedia',
    pollTypeIds: ['one-axis'],
  },
  {
    id: 'handelsblatt',
    name: 'handelsblatt',
    pollTypeIds: ['one-axis'],
  },
  {
    id: 'welttablet',
    name: 'welttablet',
    pollTypeIds: ['two-axes'],
  },
  {
    id: 'wams',
    name: 'wams',
    pollTypeIds: ['two-axes'],
  },
  {
    id: 'production',
    name: 'production',
    pollTypeIds: ['two-axes', 'financial'],
  },
  {
    id: 'cornelsen',
    name: 'cornelsen',
    pollTypeIds: ['two-axes'],
  },
  {
    id: 'foodwatch',
    name: 'foodwatch',
    pollTypeIds: ['two-axes'],
  },
]

export function selectDesignsWherePollTypeId(
  rootState: RootState,
  id: PollTypeId
): Array<Design> {
  return chain(rootState.designsStore)
    .values()
    .filter(item => {
      return includes(item.pollTypeIds, id)
    })
    .value()
}

export default function reducer(
  state: DesignsStore = upsert({}, hardcodedDesigns),
  action: Action
): DesignsStore {
  switch (action.type) {
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/designsStore.js